import { render, staticRenderFns } from "./VehicleRequestCount.vue?vue&type=template&id=34bb500d&"
import script from "./VehicleRequestCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports